<template
    v-if="moveable"
>
    <Moveable
        class="moveable target"
        style="position: absolute;"
        @click.native="(e) => handleClick(e)"
        :class="[el.isActive ? 'activePageElement' : 'inactiveElement', `${el.type}`, isLockedEl ? 'isLockedElement' : '']"
        v-bind="moveable"
        @drag="handleDrag"
        @dragEnd="handleDragEnd"
        @dragStart="handleDragStart"
        @scale="handleScale"
        @scaleEnd="handleScaleEnd"
        @scaleStart="handleScaleStart"
        @rotate="handleRotate"
        @rotateEnd="handleRotateEnd"
        @rotateStart="handleRotateStart"
        @resizeStart="handleResizeStart"
        @resize="handleResize"
        @resizeEnd="handleResizeEnd"
        @snap="handleSnap"
        ref="moveable"
        :key="`elementKey-${el.id}`"
    >
        <component 
            :is="el.type"
            :el="el"
            :title="el.type"
            :endValues="endValues"
            :transformDetails="transformDetails"
            :parentFrame="frame"
        />
    </Moveable>   
</template>

<script>
    import Moveable from 'vue-moveable';
    import { mapState, mapGetters } from 'vuex';
    import IMAGE_ELEMENT from './Elements/imageElement.vue';
    import PHOTO_CELL_ELEMENT from './Elements/photoCellElement_copy.vue';
    import SHAPE_ELEMENT from './Elements/shapeElement.vue';
    import TEXT_ELEMENT from './Elements/textElementNew.vue';
    import QR_CODE_ELEMENT from './Elements/qrCodeElement.vue';
    export default {
        props: ['el', 'parentId'],
        data() {
            return {
                moveable: {
                    draggable: false,
                    resizable: false,
                    scalable: false,
                    rotatable: false,
                    keepRatio: true,
                    pinchable: true,
                    renderDirections: ["nw", "ne", "sw", "se"],
                    snappable: true,
                    verticalGuidelines: [0, 200, 300],
                    horizontalGuidelines: [0, 100, 200],
                    elementGuidelines: [],
                    snapElement: true,
                    throttleDrag: 1,
                    throttleScale: 0.1,
                    snapCenter: true,
                    snapHorizontal: true,
                    snapVertical: true,
                    container: document.getElementById(`${this.parentId}`),
                    className: `moveable-box moveable-${this.el.id}`,
                    target: '.target'
                },
                endValues: {
                    width: 0,
                    height: 0
                },
                transformDetails: {
                    transforming: false,
                    type: null
                },
                frame: {
                    translate: [0, 0],
                    scale: [1, 1],
                    rotate: 0
                },
                dragEvents: []
            }
        },
        methods: {
            deleteElement() {
                this.$store.dispatch('REMOVE_PAGE_ELEMENT')
            },
            handleActiveClass() {
                // this.$el.focus();
                this.$parent.$children.forEach(child => {
                    child.el.isActive ?
                        (child.$refs.moveable.moveable.innerMoveable.moveable.moveable.controlBox.element.style.display = "block",
                            child.$el.focus(),
                            child.$refs.moveable.setState({}, () => {
                                child.moveable.draggable = true;
                                
                                // child.moveable.scalable = true;
                                // child.moveable.rotatable = true;
                            })
                        ) : (
                            child.$refs.moveable.moveable.innerMoveable.moveable.moveable.controlBox.element.style.display = "none",
                            child.$el.blur(),
                            child.$refs.moveable.setState({}, () => {
                                child.moveable.draggable = false;
                                
                            })
                        )
                        
                })
            },
            handleClick(e) {
                // this.$el.focus();
                if(!this.el.isActive) {
                    this.$store.dispatch('ACTIVATE_ELEMENT', this.el)
                    this.$store.dispatch('CHANGE_ACTIVE_ELEMENT', this.el)
                    if (this.el.type === 'PHOTO_CELL_ELEMENT') {
                        this.$store.dispatch('CHANGE_TAB', 'ImageTab')
                        this.$store.dispatch('UPDATE_ELEMENT', { photoCellImageIsEdited: false })
                    }
                    this.handleActiveClass();
                    if (this.el.type === 'TEXT_ELEMENT') {
                        this.$refs.moveable.setState({}, () => {
                            this.$refs.moveable.moveable.draggable = true;
                        })
                        this.$refs.moveable.moveable.innerMoveable.moveable.moveable.controlBox.element.classList.remove('text-editable');
                        let payload = {
                            variableName: 'isEdited',
                            value: false
                        }
                        this.$store.dispatch('SET_TEXT_VARIABLE', payload)
                    }

                    if (this.el.type === 'QR_CODE_ELEMENT') {
                        this.$refs.moveable.setState({}, () => {
                            this.moveable.scalable = false;
                            this.moveable.resizable = false;
                            this.moveable.keepRatio = true;
                            // this.moveable.keepRatio = true;
                            this.moveable.draggable = true;
                            this.moveable.rotatable = true;
                            // this.moveable.renderDirections = ["n", "nw", "ne", "s", "se", "sw", "e", "w"]
                        });
                    }
                }
            },
            handleDragStart({ set, currentTarget, inputEvent }) {
                set(this.frame.translate);
            
                const elementGuidelines = Array.from(document.getElementsByClassName("target"));
                currentTarget.elementGuidelines = elementGuidelines;

                this.transformDetails.transforming = false;
                this.transformDetails.type = 'drag';
            },
            handleDrag({ currentTarget, target, left, top, beforeDelta, transform, beforeTranslate, inputEvent }) {                   
                this.frame.translate = beforeTranslate;          
                
                target.style.transform = `translate(${beforeTranslate[0]}px, ${beforeTranslate[1]}px) scale(${this.frame.scale[0]}, ${this.frame.scale[1]})` + `rotate(${this.frame.rotate}deg)`;
                currentTarget.updateRect();

                this.transformDetails.transforming = true;
                this.transformDetails.type = 'drag';
            },
            handleDragEnd ({ currentTarget, target, inputEvent }) {
                this.$store.dispatch('UPDATE_ELEMENT', {
                    frame: this.frame,
                    webSizeMM: {
                        ...this.el.webSizeMM,
                        translate: [this.frame.translate[0] * 0.084667, this.frame.translate[1] * 0.084667]
                    }
                })
                this.transformDetails.transforming = false;
                this.transformDetails.type = null;
            },
            handleScaleStart({ set, dragStart, currentTarget }) {
                set(this.frame.scale);
                dragStart && dragStart.set(this.frame.translate);
                this.transformDetails.type = 'scaleStart';

                const elementGuidelines = Array.from(document.getElementsByClassName("target"));
                currentTarget.elementGuidelines = elementGuidelines;
            },
            handleScale({ target, transform, scale, currentTarget, delta, drag }) {
                currentTarget.updateRect();
                this.frame.scale = scale;
                // this.frame.translate = drag.beforeTranslate;
                target.style.transform = `translate(${this.frame.translate[0]}px, ${this.frame.translate[1]}px)` + `scale(${scale[0]}, ${scale[1]})` + `rotate(${this.frame.rotate}deg)`;

                const width = Math.sqrt(Math.pow(currentTarget.getRect().pos1[0] - currentTarget.getRect().pos2[0], 2) + Math.pow(currentTarget.getRect().pos1[1] - currentTarget.getRect().pos2[1], 2));
                const height = Math.sqrt(Math.pow(currentTarget.getRect().pos2[0] - currentTarget.getRect().pos4[0], 2) + Math.pow(currentTarget.getRect().pos2[1] - currentTarget.getRect().pos4[1], 2));
                this.endValues = {
                    width: width,
                    height: height
                }

                this.transformDetails.type = 'scale';
                this.transformDetails.transforming = true;
            },
            handleScaleEnd ({ currentTarget, target }) {
                const width = Math.sqrt(Math.pow(currentTarget.getRect().pos1[0] - currentTarget.getRect().pos2[0], 2) + Math.pow(currentTarget.getRect().pos1[1] - currentTarget.getRect().pos2[1], 2));
                const height = Math.sqrt(Math.pow(currentTarget.getRect().pos2[0] - currentTarget.getRect().pos4[0], 2) + Math.pow(currentTarget.getRect().pos2[1] - currentTarget.getRect().pos4[1], 2));
                currentTarget.updateRect();
                this.transformDetails.type = 'scaleEnd';
                this.transformDetails.transforming = false;
                
                // this.$store.dispatch('UPDATE_ELEMENT', {endValues: {
                //     width: width,
                //     height: height
                // }})
                this.$store.dispatch('UPDATE_ELEMENT', {
                    frame: this.frame,
                    webSizeMM: {
                        ...this.el.webSizeMM,
                        translate: [this.frame.translate[0] * 0.084667, this.frame.translate[1] * 0.084667]
                    }
                })
                
            },
            handleRotateStart({ set, currentTarget }) {
                set(this.frame.rotate);
                const elementGuidelines = Array.from(document.getElementsByClassName("target"));
                currentTarget.elementGuidelines = elementGuidelines;
            },
            handleRotate({ currentTarget, target, transform, rotate, beforeRotate, beforeDist, beforeDelta, delta, clientX, clientY }) {            
                this.frame.rotate = beforeRotate;
                target.style.transform = `translate(${this.frame.translate[0]}px, ${this.frame.translate[1]}px)` + `scale(${this.frame.scale[0]}, ${this.frame.scale[1]})` + `rotate(${beforeRotate}deg)`;
                currentTarget.updateRect()

                this.transformDetails.transforming = true;
                this.transformDetails.type = 'rotate';
            },
            handleRotateEnd({ currentTarget, isDrag, datas, target }) {
                this.$store.dispatch('UPDATE_ELEMENT', { frame: this.frame })

                this.transformDetails.transforming = false;
                this.transformDetails.type = null;
            },
            handleResizeStart({ target, set, setOrigin, dragStart }) {
                // Set origin if transform-orgin use %.
                setOrigin(["%", "%"]);

                // If cssSize and offsetSize are different, set cssSize. (no box-sizing)
                const style = window.getComputedStyle(target);
                const cssWidth = parseFloat(style.width);
                const cssHeight = parseFloat(style.height);
                set([cssWidth, cssHeight]);

                // If a drag event has already occurred, there is no dragStart.
                dragStart && dragStart.set(this.frame.translate);
            },
            handleResize({ target, currentTarget, width, height, delta, transform, drag }) {
                delta[0] && (target.style.width = `${width}px`);
                delta[1] && (target.style.height = `${height}px`);
                this.frame.translate = drag.beforeTranslate;
                target.style.transform = `translate(${this.frame.translate[0]}px, ${this.frame.translate[1]}px)` + `scale(${this.frame.scale[0]}, ${this.frame.scale[1]})` + `rotate(${this.frame.rotate}deg)`;

                this.transformDetails.transforming = true;
                this.transformDetails.type = 'resize';
            },
            handleResizeEnd({ target, currentTarget }) {
                const width = Math.sqrt(Math.pow(currentTarget.getRect().pos1[0] - currentTarget.getRect().pos2[0], 2) + Math.pow(currentTarget.getRect().pos1[1] - currentTarget.getRect().pos2[1], 2));
                const height = Math.sqrt(Math.pow(currentTarget.getRect().pos2[0] - currentTarget.getRect().pos4[0], 2) + Math.pow(currentTarget.getRect().pos2[1] - currentTarget.getRect().pos4[1], 2));
                this.$store.dispatch('UPDATE_ELEMENT', {endValues: {
                    width: width,
                    height: height
                }})
                this.$store.dispatch('UPDATE_ELEMENT', {
                    frame: this.frame,
                    width: width,
                    height: height,
                    webSizeMM: {
                        width: this.el.endValues.width * 0.084667,
                        height: this.el.endValues.height * 0.084667,
                        translate: [this.frame.translate[0] * 0.084667, this.frame.translate[1] * 0.084667]
                    }
                })

                this.transformDetails.transforming = false;
                this.transformDetails.type = null;
            },
            handleSnap({ elements }) {
                // console.log(elements)
            }
        },
        computed: {
            ...mapState([
                'activeElement'
            ]),
            ...mapGetters([
                'getActiveElement',
                'getPageWebSize',
                'getSessionDetails'
            ]),
            calculateGuidelines() {
                const horizontalGuidelines = [];
                horizontalGuidelines.push(0);
                horizontalGuidelines.push(this.getPageWebSize.px.height / 2);
                horizontalGuidelines.push(this.getPageWebSize.px.height);

                const verticalGuidelines = [];
                verticalGuidelines.push(0);
                verticalGuidelines.push(this.getPageWebSize.px.width / 2);
                verticalGuidelines.push(this.getPageWebSize.px.width);

                const elementGuidelines = Array.from(document.getElementsByClassName("target"));

                return {
                    horizontalGuidelines,
                    verticalGuidelines,
                    elementGuidelines
                }
            },
            isLockedEl() {
                if (this.getSessionDetails.mode === 'user') {
                    if (this.el.isLocked === true) {
                        return true;
                    } return false;
                }
                return false;
            },
            
        },
        watch: {
            el: {
                immediate: false,
                deep: true,
                handler() {
                    this.handleActiveClass();                 
                }
            },
            getActiveElement: {
                deep: true,
                handler() {
                    if (Object.keys(this.getActiveElement).length > 0) {
                        this.frame = {
                            ...this.frame,
                            scale: [this.el.frame.scale[0], this.el.frame.scale[1]],
                            translate: [this.el.frame.translate[0], this.el.frame.translate[1]]
                        }
                        this.$el.style.transform = `translate(${this.el.frame.translate[0]}px, ${this.el.frame.translate[1]}px)` + `scale(${this.el.frame.scale[0]}, ${this.el.frame.scale[1]})` + `rotate(${this.frame.rotate}deg)`;

                        if (this.el.type === 'QR_CODE_ELEMENT') {
                            this.$el.style.width = `${this.el.width}px`;
                            this.$el.style.height = `${this.el.height}px`;
                        } else {
                            this.$el.style.width = `${this.el.endValues.width}px`;
                            this.$el.style.height = `${this.el.endValues.height}px`;
                        }                        

                        this.$refs.moveable.updateRect();
                    }
                    
                }
            }
        },
        mounted() {
            if (this.el.fromProject) {
                this.$refs.moveable.moveable.innerMoveable.moveable.moveable.controlBox.element.style.display = "none",
                this.$refs.moveable.setState({}, () => {
                    this.moveable.draggable = false;
                });
            } else {
                this.$store.dispatch('CHANGE_ACTIVE_ELEMENT', this.el)
            };

            this.frame = this.el.frame;

            this.$el.focus();
            this.$el.style.transform = `translate(${this.frame.translate[0]}px, ${this.frame.translate[1]}px)` + `scale(${this.frame.scale[0]}, ${this.frame.scale[1]})` + `rotate(${this.frame.rotate}deg)`;

            this.endValues.width = this.el.width;
            this.endValues.height = this.el.height;
            this.$el.style.width = this.el.width + 'px'
            this.$el.style.height = this.el.height + 'px'

            this.$refs.moveable.updateRect();

            if (this.el.type === 'TEXT_ELEMENT') {
                this.endValues.width = this.el.endValues.width;
                this.endValues.height = this.el.endValues.height;
                this.$el.style.width = this.el.endValues.width + 'px';
                this.$el.style.height = this.el.endValues.height + 'px';
                this.$refs.moveable.moveable.updateRect();
                this.$refs.moveable.setState({}, () => {
                    this.moveable.scalable = false;
                    this.moveable.resizable = true;
                    this.moveable.keepRatio = false;
                });
            } else if (this.el.type === 'PHOTO_CELL_ELEMENT') {
                this.$refs.moveable.setState({}, () => {
                    this.moveable.scalable = true;
                    this.moveable.resizable = false;
                    this.moveable.keepRatio = true;
                });
            } else if (this.el.type === 'QR_CODE_ELEMENT') {
                this.$refs.moveable.setState({}, () => {
                    this.moveable.scalable = false;
                    this.moveable.resizable = false;
                    this.moveable.keepRatio = true;
                });
            } else {
                this.$refs.moveable.setState({}, () => {
                    this.moveable.scalable = false;
                    this.moveable.resizable = true;
                    this.moveable.keepRatio = true;
                });
            }

            this.$refs.moveable.setState({}, () => {
                this.moveable.draggable = true;
                this.moveable.rotatable = true;
            });

            const horizontalGuidelines = this.calculateGuidelines.horizontalGuidelines;
            const verticalGuidelines = this.calculateGuidelines.verticalGuidelines;
            this.$refs.moveable.setState({}, () => {
                this.moveable.horizontalGuidelines = horizontalGuidelines;
                this.moveable.verticalGuidelines = verticalGuidelines;
            });
            this.$refs.moveable.moveable.elementGuidelines = this.calculateGuidelines.elementGuidelines;

            const rect = this.$refs.moveable.getRect();

            if (this.el.newTransforms) {
                this.frame = this.el.frame;
            } else {
                this.frame.translate = [rect.left, rect.top];
                this.frame.scale = [1, 1];
            };


            if (this.el.type === 'QR_CODE_ELEMENT') {
                this.$store.dispatch('UPDATE_THIS_ELEMENT', {
                    pageId: this.el.pageId,
                    id: this.el.id,
                    values: {
                        frame: this.frame,
                        webSizeMM: {
                            width: this.el.width * 0.084667,
                            height: this.el.height * 0.084667,
                            translate: [this.frame.translate[0] * 0.084667, this.frame.translate[1] * 0.084667]
                        }
                    }
                });
                this.$el.style.width = `${this.el.width}px`;
                this.$el.style.height = `${this.el.height}px`;
            } else {
                if (this.el.type !== 'PHOTO_CELL_ELEMENT') {
                    this.$store.dispatch('UPDATE_THIS_ELEMENT', {
                        pageId: this.el.pageId,
                        id: this.el.id,
                        values: {
                            frame: this.frame,
                            webSizeMM: {
                                width: this.el.endValues.width * 0.084667,
                                height: this.el.endValues.height * 0.084667,
                                translate: [this.frame.translate[0] * 0.084667, this.frame.translate[1] * 0.084667]
                            }
                        }
                    });

                    this.$el.style.width = `${this.el.endValues.width}px`;
                    this.$el.style.height = `${this.el.endValues.height}px`;
                }
            };

            if (this.el.type !== 'PHOTO_CELL_ELEMENT') {
                this.$el.style.transform = `translate(${this.frame.translate[0]}px, ${this.frame.translate[1]}px)` + `scale(${this.frame.scale[0]}, ${this.frame.scale[1]})` + `rotate(${this.frame.rotate}deg)`;       
            }
        },
        components: {
            Moveable,
            IMAGE_ELEMENT,
            SHAPE_ELEMENT,
            PHOTO_CELL_ELEMENT,
            TEXT_ELEMENT,
            QR_CODE_ELEMENT
        },
        
    }
</script>

<style scoped>
    .moveable {
        cursor: pointer;
    }
    .moveable:focus {
        outline: none;
    }
    .isLockedElement {
        pointer-events: none;
        cursor: not-allowed;
    }
</style>